import { generateLeadEvent } from "../../../modules/tracking/AnalyticsEvents";

export default async function() {
    const modal = $('[data-remodal-id="request-callback"]').remodal({
        hashTracking: true, closeOnOutsideClick: false
    });

    const requestCallbackValidator = new ContactFormValidator;
    const requestCallbackLocationHandler = new CustomerLocationHandler;

    function initForm()
    {
        requestCallbackValidator.validate('request-callback-form');
        requestCallbackLocationHandler.setup('request-callback-form');
        dataLayer.push({
            'event' : 'trackEvent',
            'eventCategory' : 'Business - Request Callback',
            'eventAction' : 'Form Opened',
            'eventLabel' : 'Opened',
            'eventValue' : 0,
        });
        modal.open();
    }

    $( ".finance-ctas" ).on( "content:updated.request-callback", function( event ) {
        bindButtons();
    });

    function bindButtons()
    {
        $('button.request-callback').on('click', function() {
            initForm();
            var e = $(this);
            if (typeof e.data('model') !== 'undefined' && e.data('model') !== '') {
                $('#request-callback-vehicle').val(e.data('model'));
            }
            else if (typeof vehicleId !== 'undefined') {
                $('#request-callback-vehicle').val(vehicleId);
            }
        });
    }

    bindButtons();

    $('#request-callback-form').on('submit', async function (e)  {
        e.preventDefault();

        if (await requestCallbackValidator.isValid()) {
            var formData = $(this).serializeArray();

            if (typeof affinityScheme !== 'undefined') {
                formData.push({name:'affinity-scheme',value:affinityScheme});
            }

            requestCallbackValidator.preventInput();

            $.ajax({
                type: "POST",
                cache: false,
                dataType: 'json',
                url: $("#request-callback-form").attr('action'),
                data: formData,
                success: function(response) {
                    dataLayer.push({
                        'event' : 'trackEvent',
                        'eventCategory' : 'Business - Request Callback',
                        'eventAction' : 'Form Complete',
                        'eventLabel' : 'Complete',
                        'eventValue' : 0,
                    });
                    generateLeadEvent('business_request_callback');
                    $('#request-callback-form').html('<h2>Thank you for your request</h2><p class="nice-text">A confirmation email has been sent to your email address. We look forward to speaking with you!</p>');
                    requestCallbackValidator.allowInput();
                },
                error: function(response) {
                    outputErrorToForm('request-callback-form', parseErrorResponse(response));
                    requestCallbackValidator.allowInput();
                }
            });
        }

        return false;
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/fleet-and-business/forms/modules/request-callback.js